module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrapper",
    class: {
      'broad': _vm.tabB
    }
  }, [_c('div', {
    staticClass: "container",
    class: {
      'newStyle2': _vm.newStyle
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tabA),
      expression: "tabA"
    }]
  }, [_c('div', {
    staticClass: "cont-head",
    class: {
      'newStyle': !_vm.newStyle
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('sign up')))])]), _vm._v(" "), _c('div', {
    staticClass: "user-type"
  }, [_c('div', {
    staticClass: "user-left",
    class: {
      'Select2': _vm.isB, 'choose-left': _vm.isB
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.check2()
      }
    }
  }, [_c('input', {
    class: [_vm.isB ? 'hide1' : ''],
    attrs: {
      "type": "radio"
    }
  }), _vm._v(" "), _c('label', [_vm._v(_vm._s(_vm.$t('Patient')))])]), _vm._v(" "), _c('div', {
    staticClass: "user-right",
    class: {
      'Select2': _vm.isC, 'choose-right': _vm.isC
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.check2()
      }
    }
  }, [_c('input', {
    class: [_vm.isC ? 'hide1' : ''],
    attrs: {
      "type": "radio"
    }
  }), _vm._v(" "), _c('label', [_vm._v(_vm._s(_vm.$t('Caregiver')))])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.newStyle),
      expression: "newStyle"
    }],
    staticClass: "user-type"
  }, [_c('div', {
    staticClass: "user-left",
    class: {
      'Select2': _vm.isD, 'choose-left': _vm.isD
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.check3($event)
      }
    }
  }, [_c('input', {
    class: [_vm.isD ? 'hide1' : ''],
    attrs: {
      "type": "radio"
    }
  }), _vm._v(" "), _c('label', [_vm._v(_vm._s(_vm.$t('Email')))])]), _vm._v(" "), _c('div', {
    staticClass: "user-right",
    class: {
      'Select2': _vm.isE, 'choose-right': _vm.isE
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.check3($event)
      }
    }
  }, [_c('input', {
    class: [_vm.isE ? 'hide1' : ''],
    attrs: {
      "type": "radio"
    }
  }), _vm._v(" "), _c('label', [_vm._v(_vm._s(_vm.$t('Mobile')))])])]), _vm._v(" "), _c('hr', {
    class: {
      'broad': _vm.tabB
    }
  }), _vm._v(" "), _c('div', {
    attrs: {
      "id": "inputGroup"
    }
  }, [_c('div', {
    staticClass: "icon-bor"
  }, [_c('select', {
    attrs: {
      "id": "chooseCountry"
    },
    on: {
      "change": _vm.select
    }
  }, [_c('option', {
    attrs: {
      "value": "GB"
    }
  }, [_vm._v("United Kingdom (mmol/L)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "AU"
    }
  }, [_vm._v("Australia (mmol/L)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "CN"
    }
  }, [_vm._v("中国 (mmol/L)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "HKF"
    }
  }, [_vm._v("香港(中国) (mmol/L)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "TH"
    }
  }, [_vm._v("Thailand (mg/dL)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "ID"
    }
  }, [_vm._v("Indonesia (mg/dL)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "MY"
    }
  }, [_vm._v("Malaysia (mmol/L)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "IN"
    }
  }, [_vm._v("India (mg/dL)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "FR"
    }
  }, [_vm._v("France (mg/dL)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "DE"
    }
  }, [_vm._v("Deutschland (mg/dL)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "DD"
    }
  }, [_vm._v("Deutschland (mmol/L)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "HU"
    }
  }, [_vm._v("Magyarország (mmol/L)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "IT"
    }
  }, [_vm._v("Italia (mg/dL)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "NL"
    }
  }, [_vm._v("Nederland (mmol/L)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Nor"
    }
  }, [_vm._v("Norge (mmol/L)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "PT"
    }
  }, [_vm._v("Portugal (mg/dL)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "ES"
    }
  }, [_vm._v("España (mg/dL)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "SE"
    }
  }, [_vm._v("Sverige (mmol/L)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "TR"
    }
  }, [_vm._v("Turkey (mg/dL)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Ro"
    }
  }, [_vm._v("Romania (mg/dL)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "CZ"
    }
  }, [_vm._v("Czech republika (mmol/L)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "SK"
    }
  }, [_vm._v("Slovenska republika (mmol/L)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "LT"
    }
  }, [_vm._v("Lithuania (mmol/L)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "PL"
    }
  }, [_vm._v("Polska (mg/dL)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "DK"
    }
  }, [_vm._v("Danmark (mmol/L)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "FI"
    }
  }, [_vm._v("Suomi (mmol/L)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "CH"
    }
  }, [_vm._v("Switzerland (mmol/L)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "SA"
    }
  }, [_vm._v("Saudi  (mg/dL)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "AE"
    }
  }, [_vm._v("United Arab (mmol/L)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "QA"
    }
  }, [_vm._v("Qatar  (mmol/L)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "QW"
    }
  }, [_vm._v("Kuwait (mmol/L)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "RH"
    }
  }, [_vm._v("Croatia (mmol/L)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "AT"
    }
  }, [_vm._v("Austria (mg/dL)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "SI"
    }
  }, [_vm._v("Slovenia (mmol/L)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "EE"
    }
  }, [_vm._v("Estonia (mmol/L)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "LV"
    }
  }, [_vm._v("Latvia (mmol/L)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "BA"
    }
  }, [_vm._v("Bosnia and Herzegovina (mmol/L)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "BG"
    }
  }, [_vm._v("Bulgaria (mmol/L)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "CL"
    }
  }, [_vm._v("Chile (mmol/L)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "BE"
    }
  }, [_vm._v("Belgium (mg/L)")])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isD),
      expression: "isD"
    }],
    staticClass: "icon-bor icon-spe4",
    class: {
      'in': _vm.isF, 'vuerify-invalid': _vm.isO
    }
  }, [_c('el-tooltip', {
    attrs: {
      "disabled": _vm.disA,
      "placement": "top",
      "effect": "light",
      "offset": "-30"
    }
  }, [_c('div', {
    staticClass: "tooltip",
    slot: "content"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('errtip1-1')))]), _c('br'), _c('span', [_vm._v(_vm._s(_vm.$t('errtip1-2')))])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }],
    attrs: {
      "type": "text",
      "placeholder": _vm.Ema
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "down", 40)) { return null; }
        _vm.down(1)
      },
      "focus": function($event) {
        _vm.check54(0)
      },
      "blur": function($event) {
        _vm.check54(1)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "time",
    class: {
      'in2': (_vm.isF || _vm.isO), 'zh1': _vm.newStyle
    }
  }, [_c('button', {
    attrs: {
      "disabled": _vm.canClick
    },
    on: {
      "click": _vm.sendSeccode
    }
  }, [_c('label', [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showTime),
      expression: "showTime"
    }],
    staticClass: "showTime"
  }, [_vm._v(_vm._s(_vm.time))]), _vm._v(_vm._s(_vm.send))])])])], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isE),
      expression: "isE"
    }],
    staticClass: "icon-spe1",
    class: {
      'in': _vm.isG, 'vuerify-invalid': _vm.isP
    }
  }, [_c('el-tooltip', {
    attrs: {
      "disabled": _vm.disB,
      "placement": "top",
      "effect": "light"
    }
  }, [_c('div', {
    staticClass: "tooltip",
    slot: "content"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('errtip2')))])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.mobile),
      expression: "mobile"
    }],
    attrs: {
      "type": "text",
      "placeholder": _vm.Mob
    },
    domProps: {
      "value": (_vm.mobile)
    },
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "down", 40)) { return null; }
        _vm.down(1)
      },
      "focus": function($event) {
        _vm.check55(0)
      },
      "blur": function($event) {
        _vm.check55(1)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.mobile = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "time",
    class: {
      'in2': (_vm.isG || _vm.isP), 'zh1': _vm.newStyle
    }
  }, [_c('button', {
    attrs: {
      "disabled": _vm.canClick
    },
    on: {
      "click": _vm.sendSeccode
    }
  }, [_c('label', [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showTime),
      expression: "showTime"
    }],
    staticClass: "showTime"
  }, [_vm._v(_vm._s(_vm.time))]), _vm._v(_vm._s(_vm.send))])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "icon-spe2",
    class: {
      'in': _vm.isH, 'vuerify-invalid': _vm.isQ
    }
  }, [_c('el-tooltip', {
    attrs: {
      "disabled": _vm.disC,
      "placement": "top",
      "effect": "light"
    }
  }, [_c('div', {
    staticClass: "tooltip",
    slot: "content"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('errtip3')))])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.vcode),
      expression: "vcode"
    }],
    attrs: {
      "type": "text",
      "autocomplete": "new-password",
      "placeholder": _vm.Veri
    },
    domProps: {
      "value": (_vm.vcode)
    },
    on: {
      "keyup": [function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "down", 40)) { return null; }
        _vm.down(2)
      }, function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "up", 38)) { return null; }
        _vm.up(2)
      }],
      "focus": function($event) {
        _vm.check56(0)
      },
      "blur": function($event) {
        _vm.check56(1)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.vcode = $event.target.value
      }
    }
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "icon-bor",
    class: {
      'in': _vm.isJ, 'vuerify-invalid': _vm.isS
    }
  }, [_c('el-tooltip', {
    attrs: {
      "disabled": _vm.disE,
      "placement": "top",
      "effect": "light"
    }
  }, [_c('div', {
    staticClass: "tooltip",
    slot: "content"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('errtip5')))])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.realname),
      expression: "realname"
    }],
    attrs: {
      "type": "text",
      "autocomplete": "new-password",
      "placeholder": _vm.fullname
    },
    domProps: {
      "value": (_vm.realname)
    },
    on: {
      "keyup": [function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "down", 40)) { return null; }
        _vm.down(4)
      }, function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "up", 38)) { return null; }
        _vm.up(4)
      }],
      "focus": function($event) {
        _vm.check58(0)
      },
      "blur": function($event) {
        _vm.check58(1)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.realname = $event.target.value
      }
    }
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "icon-bor",
    class: {
      'in': _vm.isK, 'vuerify-invalid': _vm.isT
    }
  }, [_c('el-tooltip', {
    attrs: {
      "disabled": _vm.disF,
      "placement": "bottom",
      "effect": "light"
    }
  }, [_c('div', {
    staticClass: "tooltip",
    slot: "content"
  }, [_c('p', {
    staticClass: "longP",
    class: {
      'correct1': _vm.ps1
    }
  }, [_vm._v(_vm._s(_vm.$t('errp1'))), _c('br'), _vm._v(_vm._s(_vm.$t('errp2')))]), _vm._v(" "), _c('p', {
    class: {
      'correct': _vm.ps2
    }
  }, [_vm._v(_vm._s(_vm.$t('errp3')))]), _vm._v(" "), _c('p', {
    class: {
      'correct': _vm.ps3
    }
  }, [_vm._v(_vm._s(_vm.$t('errp4')))]), _vm._v(" "), _c('p', {
    class: {
      'correct': _vm.ps4
    }
  }, [_vm._v(_vm._s(_vm.$t('errp5')))]), _vm._v(" "), _c('p', {
    class: {
      'correct': _vm.ps5
    }
  }, [_vm._v(_vm._s(_vm.$t('errp6')))]), _vm._v(" "), _c('p', {
    class: {
      'correct': _vm.ps6
    }
  }, [_vm._v(_vm._s(_vm.$t('errp7')))])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    staticClass: "longps",
    attrs: {
      "type": "password",
      "autocomplete": "new-password",
      "placeholder": _vm.Enterpas
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "up", 38)) { return null; }
        _vm.up(5)
      },
      "focus": function($event) {
        _vm.check59(0)
      },
      "blur": function($event) {
        _vm.check59(1)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  })])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "operate",
    class: [_vm.isA ? 'xSelect' : 'xnoSelect']
  }), _vm._v(" "), _c('div', {
    staticClass: "next_btn",
    on: {
      "click": _vm.register
    }
  }, [_c('button', {
    staticClass: "register",
    class: {
      'click': true, 'newStyle1': !_vm.newStyle
    },
    attrs: {
      "disabled": _vm.isNext
    }
  }, [_vm._v(_vm._s(_vm.$t('Next')))])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tabB),
      expression: "tabB"
    }]
  }, [_c('div', {
    staticClass: "policy-wrap"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (true),
      expression: "true"
    }],
    staticClass: "text_wrap"
  }, [_c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.$t('t1222_We_will_only_process'))
    }
  }), _c('br'), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isB),
      expression: "isB"
    }]
  }, [(_vm.isEU) ? _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.$t('t1221_register_eu'))
    }
  }) : _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.$t('t1221_register_cn'))
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.$t('t1222_If_you_are_under_years'))
    }
  }), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', {
    staticClass: "check",
    class: [_vm.isA ? 'Select' : 'noSelect']
  }, [_c('input', {
    attrs: {
      "type": "checkbox"
    },
    on: {
      "click": function($event) {
        _vm.check1()
      }
    }
  }), _vm._v(" "), _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.$t('t1222_I_Agree_to').replace('$1', '<a href="' + _vm.termsOfUseURL + '" target="_blank">' + _vm.$t('t1222_Terms_of_Use') + '</a>'))
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "check",
    class: [_vm.isA2 ? 'Select' : 'noSelect']
  }, [_c('input', {
    attrs: {
      "type": "checkbox"
    },
    on: {
      "click": function($event) {
        _vm.check1_2()
      }
    }
  }), _vm._v(" "), _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.$t('t1222_I_Agree_to').replace('$1', '<a href="' + _vm.privacyURL + '" target="_blank">' + _vm.$t('t1222_Privacy_Policy') + '</a>'))
    }
  })]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('button', {
    staticClass: "create-account",
    class: {
      'click': _vm.isAgree, 'newStyle1': !_vm.newStyle
    },
    attrs: {
      "disabled": !_vm.isAgree
    },
    on: {
      "click": _vm.register
    }
  }, [_vm._v(_vm._s(_vm.$t('t1222_Create_Account')))]), _vm._v(" "), _c('span', {
    staticClass: "back-link"
  }, [_c('a', {
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": function($event) {
        _vm.registerBack()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('Back')))])])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-bc5f47a6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Sign.vue
// module id = 1495
// module chunks = 7